<template>
  <input
    ref="inputRef"
    type="text"
    class="el-input__inner"
    style="width: 200px !important;height: 50px !important; font-size: medium; font-weight: bold;"
    @blur="changeValue"
    @focus="focus"
    :controls="false"
  />
</template>

<script>
import { watch } from '@vue/composition-api'
import { useCurrencyInput } from 'vue-currency-input'

export default {
  name: 'CurrencyInput',
  props: {
    value: Number, // Vue 2: value  // Vue 3: modelValue
    options: Object,
  },
  setup(props) {
    const { inputRef, setValue, setOptions } = useCurrencyInput(props.options)
    watch(
      () => props.value, // Vue 2: props.value  // Vue 3: props.modelValue
      (value) => {
        setValue(value)
      }
    )

    watch(
      () => props.options,
      (options) => {
        setOptions(options)
      }
    )
    return { inputRef }
  },
  methods: {
    changeValue() {
        this.$emit('update:value', this.inputRef.value)
        this.$emit('blur')
    },
    focus() {
        this.$emit('focus')
    }
  },
}
</script>